import { useLocation, useSearchParams } from 'react-router-dom';

export function usePageNavigation() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedPage = Number(searchParams.get('page'));
  const page = Number.isSafeInteger(requestedPage) && requestedPage > 0 ? requestedPage : 1;

  const setPage = (nextPage: number) => {
    const nextSearchParams = new URLSearchParams(searchParams);
    if (nextPage <= 1) nextSearchParams.delete('page');
    else nextSearchParams.set('page', String(nextPage));
    setSearchParams(nextSearchParams, { replace: true });
  };

  return {
    page,
    setPage,
    returnTo: `${location.pathname}${location.search}`,
  };
}

export function useReturnTo(fallback: string): string {
  const [searchParams] = useSearchParams();
  const requestedReturnTo = searchParams.get('returnTo');
  return requestedReturnTo?.startsWith('/') && !requestedReturnTo.startsWith('//')
    ? requestedReturnTo
    : fallback;
}
